import styled from '@emotion/styled';

import { Link, useNavigate } from 'react-router-dom';

import { Grid, Card, CardHeader, CardContent, IconButton, Button, useTheme } from '@mui/material';

import { CardBlockContainer, CardBlock, CardBlockHeader, CardSpacer } from '../../../utils/utilities/CardComponents';

import MultiStatusChip from '../../../utils/utilities/MultiStatusChip';

import SimpleChip from '../../../utils/utilities/SimpleChip';

import { relativeTime, formatPhoneNumber, formatGenericDateTime } from '../../../utils/util';

import { BasicFlex } from '../../../utils/Common';

import useSimpleTable from '../../../hooks/useSimpleTable';

import SimplePagination from '../../../utils/utilities/SimplePagination';


import TimelineItem from '../../../utils/utilities/TimelineItem';


// use pageData context
import { usePageData } from '../../../contexts/PageData';

import ServiceHistoryComponent from '../Components/ServiceHistoryComponent';

const Pagination = styled.div`
  margin-top: 5rem;
`

const ServiceHistoryTab = () => {
  const { data = {} } = usePageData();

  return (
    <Grid container spacing={3}>

      <Grid size={{xs: 12, lg: 8, xl: 6}}>
       <ServiceHistoryComponent inventory_id={data?.inventory_id} />
      </Grid>

    </Grid>
  );

};

export default ServiceHistoryTab;